import React from 'react';
import { motion } from 'framer-motion';
import { Coffee, MapPin } from 'lucide-react';
import { appScreenshots } from '../../data/mock';
import { useTranslation } from 'react-i18next';

export const DailyUseSection = () => {
  const { t } = useTranslation();
  return (
    <section id="daily-use" className="py-24 bg-white overflow-hidden border-t border-slate-100">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="bg-[#FAF9F6] rounded-[2.5rem] p-8 md:p-16 border border-slate-200 relative overflow-hidden">
          
          {/* Decorative background circle */}
          <div className="absolute top-0 right-0 -translate-y-1/2 translate-x-1/3 w-96 h-96 bg-yellow-100 rounded-full blur-3xl opacity-50 pointer-events-none" />

          <div className="grid lg:grid-cols-2 gap-12 items-center relative z-10">
            
            {/* Left: Text Content */}
            <motion.div 
              initial={{ opacity: 0, x: -30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
            >
              <h2 className="text-4xl md:text-5xl font-black text-slate-900 mb-6 leading-tight">
                {t('dailyUse.title1')} <br className="hidden md:block" />
                {t('dailyUse.title2')}
              </h2>
              
              <p className="text-lg text-slate-600 leading-relaxed mb-8">
                {t('dailyUse.desc')}
              </p>

              <div className="flex items-center gap-4 p-4 bg-white rounded-2xl border border-slate-200 shadow-sm max-w-sm">
                <div className="w-12 h-12 rounded-full bg-slate-100 flex items-center justify-center shrink-0">
                  <MapPin className="w-6 h-6 text-slate-600" />
                </div>
                <div>
                  <h4 className="font-semibold text-slate-900">{t('dailyUse.cardTitle')}</h4>
                  <p className="text-sm text-slate-500">{t('dailyUse.cardDesc')}</p>
                </div>
              </div>
            </motion.div>

            {/* Right: Visual (Local map snippet) */}
            <motion.div 
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.2 }}
              className="relative rounded-[2rem] overflow-hidden border border-slate-200 shadow-xl"
            >
              <img 
                src={appScreenshots.map} 
                alt="Mapa local con pines" 
                className="w-full object-cover h-[400px] hover:scale-105 transition-transform duration-700" 
              />
              {/* Overlay gradient to make it look embedded */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent pointer-events-none" />
            </motion.div>

          </div>
        </div>
      </div>
    </section>
  );
};
